module.exports = __webpack_public_path__ + "static/media/Samsung.077c53a6.jpg";